// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3rnNP","info":"UpdateTermsInfo_info__1FoZM"};